import React from "react";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

// MUI X Provider
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// Context Provider
import KpiCards from "components/graphs/KpiCards";
import DashboardFilters from "custom-components/DashboardComponents/DashboardFilters";
import {DashboardFilterProvider} from "../../contexts/DashboardFilterContext";
import ContentTypeStackedChart from "components/graphs/ContentTypeStackedChart";
import SocialSharesPlatformChart from "components/graphs/SocialSharesPlatformChart";
import SharedMatchPlatformChart from "components/graphs/SharedMatchPlatformChart";
import MostSharedEventPlatformChart from "components/graphs/MostSharedEventPlatformChart";

export default function DashboardPage() {  
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DashboardFilterProvider>
        <Box sx={{ pt: 1 }}>
          <Grid container spacing={2}>
            
            {/* Filtri superiori */}
            <Grid size={{ xs: 12 }}>
              <DashboardFilters />
            </Grid>

            <KpiCards />

            {/* Le 3 card grafici grandi */}
            <Grid size={{ xs: 12 }}>
              <ContentTypeStackedChart />
            </Grid>

            <Grid size={{ xs: 12}}>
              <SocialSharesPlatformChart />
            </Grid>

            <Grid size={{ xs: 12}}>
              <SharedMatchPlatformChart />
            </Grid>

            <Grid size={{ xs: 12}}>
              <MostSharedEventPlatformChart />
            </Grid>
            
          </Grid>
        </Box>
      </DashboardFilterProvider>
    </LocalizationProvider>
  );
}